$('.recenze-wrap .wrapRec').slick({
 slidesToShow: 3,
 slidesToScroll: 1,
 autoplay: true,
 autoplaySpeed: 10000,
 dots: true,
 arrows: false,
 infinite: false,
 adaptiveHeight: false,
 responsive: [
   {
     breakpoint: 1199,
     settings: {
       slidesToShow: 2,
       slidesToScroll: 1,
       arrows: false,
       dots: true,
     }
   },
   {
     breakpoint: 767,
     settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    }
    
   }
 ]
});